// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].rules[0].oneOf[1].use[0]!../../../../node_modules/@angular-devkit/build-angular/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].rules[0].oneOf[1].use[1]!../../../assets/css/pages/login/login-4.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kt-grid__item.kt-grid__item--fluid.kt-grid.kt-grid--hor {
  background-image: url('bg-12.jpg');
  position: absolute;
}
 
.kt-grid__item.kt-grid__item--fluid.kt-login__wrapper{
  /*position: absolute;
  top: 15%;
  left: 37%;*/
    z-index: 100;
}



.form-control {
  background: #fff !important;
  color: #008fc7 !important;
}

.btn.btn-label-brand.btn-login{
  background-color: rgba(0, 183, 255, 0.38);
  color: #95e1ff;
}


.btn.btn-label-brand.btn-login:hover {
  background-color: rgba(0, 183, 255, 0.72);
  color: #f0fbff;
}


:host {
  position: relative;
  width: 100%;
  height: 100vh; /* Adjust height as needed */
  overflow: hidden; /* Prevent scrollbars */
}

:host {
  position: relative;
  width: 100%;
  height: 100vh; /* Full viewport height */
  overflow: hidden; /* Prevent scrollbars */
}

body {
  margin: 0; /* Remove default margin */
  overflow: hidden; /* Prevent scrolling */
  background-color: black; /* Set a background color to see particles clearly */
}`, "",{"version":3,"sources":["webpack://./src/app/views/login/login.component.css"],"names":[],"mappings":"AAEA;EACE,kCAA2D;EAC3D,kBAAkB;AACpB;;AAEA;EACE;;aAEW;IACT,YAAY;AAChB;;;;AAIA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;;AAGA;EACE,yCAAyC;EACzC,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,4BAA4B;EAC3C,gBAAgB,EAAE,uBAAuB;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,yBAAyB;EACxC,gBAAgB,EAAE,uBAAuB;AAC3C;;AAEA;EACE,SAAS,EAAE,0BAA0B;EACrC,gBAAgB,EAAE,sBAAsB;EACxC,uBAAuB,EAAE,oDAAoD;AAC/E","sourcesContent":["@import \"../../../assets/css/pages/login/login-4.css\";\r\n\r\n.kt-grid__item.kt-grid__item--fluid.kt-grid.kt-grid--hor {\r\n  background-image: url('../../../assets/media/bg/bg-12.jpg');\r\n  position: absolute;\r\n}\r\n \r\n.kt-grid__item.kt-grid__item--fluid.kt-login__wrapper{\r\n  /*position: absolute;\r\n  top: 15%;\r\n  left: 37%;*/\r\n    z-index: 100;\r\n}\r\n\r\n\r\n\r\n.form-control {\r\n  background: #fff !important;\r\n  color: #008fc7 !important;\r\n}\r\n\r\n.btn.btn-label-brand.btn-login{\r\n  background-color: rgba(0, 183, 255, 0.38);\r\n  color: #95e1ff;\r\n}\r\n\r\n\r\n.btn.btn-label-brand.btn-login:hover {\r\n  background-color: rgba(0, 183, 255, 0.72);\r\n  color: #f0fbff;\r\n}\r\n\r\n\r\n:host {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100vh; /* Adjust height as needed */\r\n  overflow: hidden; /* Prevent scrollbars */\r\n}\r\n\r\n:host {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100vh; /* Full viewport height */\r\n  overflow: hidden; /* Prevent scrollbars */\r\n}\r\n\r\nbody {\r\n  margin: 0; /* Remove default margin */\r\n  overflow: hidden; /* Prevent scrolling */\r\n  background-color: black; /* Set a background color to see particles clearly */\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
